import { render, staticRenderFns } from "./Badge16.vue?vue&type=template&id=32a79662&scoped=true"
import script from "./Badge16.vue?vue&type=script&lang=js"
export * from "./Badge16.vue?vue&type=script&lang=js"
import style0 from "./Badge16.vue?vue&type=style&index=0&id=32a79662&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a79662",
  null
  
)

export default component.exports